import React from "react";
import { Inbox } from "lucide-react";

export function EmptyState({
    icon: Icon = Inbox,
    title = "Nessun dato",
    description = "",
    action = null,
}) {
    return (
        <div
            data-testid="empty-state"
            className="flex flex-col items-center justify-center py-16 px-6 text-center bg-white rounded-xl border border-[#DCE3EE]"
        >
            <div className="w-14 h-14 rounded-full bg-[#F5F7FB] flex items-center justify-center mb-4">
                <Icon className="w-6 h-6 text-[#64748B]" strokeWidth={1.75} />
            </div>
            <h3 className="text-lg font-semibold text-[#172033]">{title}</h3>
            {description && (
                <p className="text-sm text-[#64748B] mt-2 max-w-md">{description}</p>
            )}
            {action && <div className="mt-6">{action}</div>}
        </div>
    );
}

export default EmptyState;
